import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
/**
 * ReceiptInfoText
 */
const getColor = ({ theme, variant, }) => ({
    default: theme.colors.base.textBody,
    highlighted: theme.colors.base.textNode,
    support: theme.colors.informative.textSupport,
})[variant];
export const receiptInfoTextStyles = ({ theme, $variant = 'default', }) => css `
	margin: 0;
	color: ${getColor({ theme, variant: $variant })};
`;
export const StyledReceiptInfoText = styled(Typography).attrs({
    variant: 'body-text-xs',
    tagName: 'p',
}) `
	${receiptInfoTextStyles}
`;
